<template>
  <h2 class="header">
    {{ $t("message.companyProfile.listings.subtitle.mainSection") }}
  </h2>
</template>

<script>
export default {
  name: "FacebookAccountsHeader"
};
</script>
<style lang="scss" scoped>
.header {
  @include font-size(16px);
  line-height: 32px;
  padding-left: 12px;
  border-left: 3px solid #dbda1f;
  font-weight: 500;
}
</style>
